import { useEffect, useRef, useLayoutEffect, useState } from 'react';

function useEventListener({ eventName, handler, initialEnabled, element, options }) {
    // Create a ref that stores handler
    const savedHandler = useRef(handler);
    const [ isEnabled, setIsEnabled ] = useState(initialEnabled ?? true);

    useLayoutEffect(() => {
        savedHandler.current = handler;
    }, [ handler ]);

    useEffect(() => {
        if (!isEnabled) {
            return;
        }
        
        // Define the listening target
        const targetElement = element?.current ?? window;

        if (targetElement?.addEventListener == null || savedHandler.current == null) {
            return;
        }

        // Create event listener that calls handler function stored in ref        
        targetElement.addEventListener(eventName, savedHandler.current, options);

        // Remove event listener on cleanup
        return () => {
            targetElement.removeEventListener(eventName, savedHandler.current, options);
        };
    }, [ eventName, element, options, isEnabled ]);
    
    return {
      disable: () => setIsEnabled(false),
      enable: () => setIsEnabled(true),
      toggle: (value) => setIsEnabled(prev => value != null ? value : !prev),
      isEnabled,  
    };
}

export default useEventListener;